import PropTypes from 'prop-types';

const BuildingSingle = ({ color, size, ...props }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            d="M7 19V5h10v14h-2v-2a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2zm4 0h2v-2h-2zm0 2H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-7M9 6h2v2H9zm4 0h2v2h-2zm-4 4h2v2H9zm4 0h2v2h-2z"
            fill={color}
            fillRule="evenodd"
        />
    </svg>
);

export default BuildingSingle;

BuildingSingle.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
